export * from './GalleryCard';
export { default } from './GalleryCard';
